import { render } from "./ClientSettingsIntegration.vue?vue&type=template&id=2dd733ba&scoped=true"
import script from "./ClientSettingsIntegration.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientSettingsIntegration.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientSettingsIntegration.vue?vue&type=style&index=0&id=2dd733ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd733ba"]])

export default __exports__